import { match } from 'path-to-regexp'

interface PageRouteResult {
  pageId?: string
  isTemplate: boolean
}

interface MatchParams {
  id: string
  [key: string]: string | string[]
}

export default function usePageRouteDetector(): PageRouteResult {
  const pathname = window.location.pathname

  const routes: { pattern: string; isTemplate: boolean }[] = [
    { pattern: '/page/:id/edit', isTemplate: false },
    { pattern: '/dashboard/page/:id/edit', isTemplate: false },
    { pattern: '/page/template/:id/edit', isTemplate: true },
    { pattern: '/dashboard/page/template/:id/edit', isTemplate: true },
  ]

  for (const { pattern, isTemplate } of routes) {
    const matcher = match<MatchParams>(pattern, {})
    const result = matcher(pathname)

    if (result) {
      const { id } = result.params
      if (id && Number.isInteger(+id)) {
        return {
          pageId: id,
          isTemplate,
        }
      }
    }
  }

  return { isTemplate: false }
}
